'use client';

import React from 'react';
import { Locale } from '../../../../i18n-config';
import { useTranslation } from '@/i18n/client';
import FinalCTA from '../_shared/sections/FinalCTA';

type Props = { lang: Locale };

const SignupFormsFinalCTA = ({ lang }: Props) => {
  const { t } = useTranslation(lang);

  return (
    <FinalCTA
      accent="#22D3EE"
      ariaLabel={t('SignupForms/FinalCTA/aria_label')}
      copy={{
        headlineA: t('SignupForms/FinalCTA/title1'),
        headlineB: t('SignupForms/FinalCTA/title2'),
        subhead: t('SignupForms/FinalCTA/subtitle'),
        ctaPrimary: {
          label: t('SignupForms/FinalCTA/cta_primary'),
          href: `${process.env.NEXT_PUBLIC_DASHBOARD_BASE_URL}/register`,
        },
        ctaSecondary: {
          label: t('SignupForms/FinalCTA/cta_secondary'),
          href: `/${lang}/contact-us`,
        },
      }}
    />
  );
};

export default SignupFormsFinalCTA;
